import css from "./style.scss";
import cx from "classnames";
import useInvoice from "../../hooks/useInvoice";

const NetworkListItem = ({ item }) => {
  const { network } = item;
  const { selectNetwork } = useInvoice();

  return (
    <li onClick={() => selectNetwork(item)} class={cx(css.item)}>
      <div class={cx(css.name)}>{network}</div>
      <div class={cx(css.value)}></div>
    </li>
  );
};

const NetworkList = ({ list = [] }) => (
  <ul class={cx(css.list)}>
    {list.map((el) => (
      <NetworkListItem item={el} />
    ))}
  </ul>
);

export default NetworkList;
